import Model, { attr } from '@ember-data/model';

import type { BillingCycle } from 'webapp/enums/enums';

import type { Metadata } from 'webapp/models-custom/space';

export interface SpaceDatasource {
	name: string;
	count: number;
}

export interface SpaceDataset {
	name: string;
	count: number;
}

export interface SpaceBillingInfo {
	planId: string;
	productName: string;
	subscriptionStatus: string;
	totalPrice: number;
	totalPriceFormatted: string;
	billingCycle: BillingCycle;
	activeUntil: number | null;
}

export default class SpaceRecord extends Model {
	@attr('number') accountType!: number;
	@attr('string') companyName!: string;
	@attr('string') websiteUrl!: string;
	@attr('boolean') isEnterprise!: boolean;
	@attr('number') created!: number;
	@attr('string') createdByName!: string;
	@attr('string') color!: string; // hex
	@attr('number', { defaultValue: 0 }) boardCount!: number;
	@attr('number', { defaultValue: 0 }) sourceCount!: number;
	@attr('number', { defaultValue: 0 }) datasetCount!: number;
	@attr('number', { defaultValue: 0 }) userCount!: number;
	@attr('number', { defaultValue: 0 }) customMetricCount!: number;
	@attr('number', { defaultValue: 0 }) reportCount!: number;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	datasources!: SpaceDatasource[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	datasets!: SpaceDataset[];
	@attr('number') ownerId!: number;
	@attr('number') accountManagerId!: number;
	@attr('number') activeUntil!: number;
	@attr('string') adminName!: string;
	@attr('string') adminEmail!: string;
	@attr('number') order!: number; // semi-legacy: still used / changeable in client overview, however sidebar clients list uses alphabetical
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	tags!: number[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	stepsCompleted!: number[];
	@attr('boolean', { defaultValue: false }) hidden!: boolean;
	@attr('object', {
		defaultValue() {
			return {
				industries: [],
				businessClassifications: [],
				employees: null,
				revenue: null,
				cloudSourcesOpportunity: [],
				sourcesSelection: [],
				goal: null,
			};
		},
	})
	metadata!: Metadata;

	@attr('number') parentResellerId!: number | null;
	@attr('object')
	billingInfo!: SpaceBillingInfo;

	// only for internal webapp use
	@attr('boolean') newBadge!: boolean;
}
